
const NotFound = () => {
  return <div>Error 404</div>
}

export default NotFound